import { Mail, Phone } from 'lucide-react';
import PageBackdrop from '../components/PageBackdrop';
import { PAGE_BACKGROUNDS } from '../constants/brand';
import usePageTitle from '../hooks/usePageTitle';

const FOUNDERS = [
  { name: 'Priyanshi Agrawal', credential: 'BSc in Filmmaking' },
  { name: 'Rohit Agrawal', credential: 'BSc in Filmmaking' },
];

const Contact = () => {
  usePageTitle('Contact');
  return (
    <div className="min-h-screen bg-black film-grain relative overflow-hidden pt-32 pb-24">
      <PageBackdrop imageUrl={PAGE_BACKGROUNDS.contact} opacity={0.2} />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <p className="chapter-label mb-6">CONTACT</p>
        <h1 className="display-heading text-5xl md:text-6xl text-white mb-6">
          Reach the <em>team.</em>
        </h1>
        <p className="text-base text-zinc-400 leading-relaxed mb-16 max-w-xl">
          Questions about courses, partnerships, or the platform - we read every message.
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="chapter-label mb-6">FOUNDERS</p>
            <div className="space-y-4">
              {FOUNDERS.map((founder) => (
                <div key={founder.name} className="cine-card p-6 border border-white/5">
                  <h3 className="font-serif text-xl text-white mb-1">{founder.name}</h3>
                  <p className="text-sm text-zinc-400">{founder.credential}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <p className="chapter-label mb-6">TEAM</p>
            <div className="cine-card p-8 md:p-10 space-y-8">
              <p className="text-sm text-zinc-400 leading-relaxed">
                For general enquiries, collaborations, and support - contact the Cynopsis team below.
              </p>

              <div className="flex items-start gap-4">
                <Mail className="w-5 h-5 text-[#C8102E] flex-shrink-0 mt-1" />
                <div>
                  <p className="text-xs tracking-[0.2em] uppercase text-zinc-500 mb-2">Email</p>
                  <a
                    href="mailto:cynopsis1601@gmail.com"
                    className="text-base text-zinc-200 hover:text-[#C8102E] transition-colors"
                  >
                    info@cynopsis.in
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Phone className="w-5 h-5 text-[#C8102E] flex-shrink-0 mt-1" />
                <div>
                  <p className="text-xs tracking-[0.2em] uppercase text-zinc-500 mb-2">Phone</p>
                  <a
                    href="tel:+917697632940"
                    className="text-base text-zinc-200 hover:text-[#C8102E] transition-colors"
                  >
                    +91 76976 32940
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
